/**
 * Base URL for REST calls (must end with /api to match FastAPI routes).
 */
function envBackendOrigin() {
  return (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000')
    .trim()
    .replace(/\/+$/, '')
    .replace(/\/api\/?$/i, '');
}

export function getApiBaseUrl() {
  const backend = envBackendOrigin();

  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const isPageLocal = hostname === 'localhost' || hostname === '127.0.0.1';

    if (process.env.NODE_ENV === 'development') {
      // Desktop admin: call backend directly (avoids proxy 504 when backend is up)
      if (isPageLocal) {
        return `${backend}/api`;
      }
      // Phone on LAN: same-origin proxy via webpack dev server
      const origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
      return `${origin}/api`;
    }

    if (!isPageLocal) {
      return `${backend.replace(/localhost|127\.0\.0\.1/gi, hostname)}/api`;
    }
  }

  return `${backend}/api`;
}

/** Origin for static uploads served by FastAPI (/uploads/...) */
export function getBackendOrigin() {
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    const { protocol, hostname, port } = window.location;
    const isPageLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isPageLocal) {
      return envBackendOrigin();
    }
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }
  return getApiBaseUrl().replace(/\/api\/?$/i, '');
}

export function resolveMediaUrl(url) {
  if (!url) return null;
  // Supabase Storage and other absolute URLs — use as-is
  if (/^https?:\/\//i.test(url)) return url;
  // Legacy FastAPI relative paths (/uploads/vehicles/...)
  const origin = getBackendOrigin();
  return `${origin}${url.startsWith('/') ? url : `/${url}`}`;
}

/** Resolves fresh base URL on each use (template literals, axios, etc.) */
export const API = {
  toString() {
    return getApiBaseUrl();
  },
  valueOf() {
    return getApiBaseUrl();
  },
};
